/**
 * Classe que gerencia a exibição e eventos da funcionalidade de
 * atribuir equipamento à rota.
 *
 * @author: Adalto Junior
 * DATE: 18/03/2013
 *
 */


Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.AssignEquipment = function ({
  modalContentSelector = '#Route .popupFormContainer',
  routeId = App.Forms.Route.form.fields.id.getValue(),
  scopeBlock = '#Route form.MonetUIForm.Route',
  selector = '#Route #form_and_grid',
  successCallback,
  afterRemoveItems
} = {}) {

    this.modalForm = null;

    this.showAssignEquipment = function () {
        this.modalForm.showModalForm();
    };

    this.addFormToModalContent = () => {

        const modalContent = document.querySelector(modalContentSelector);

        if (modalContent) {

            try {

                const contentToModal = this.constructFormAssignEquipment(routeId);

                modalContent.appendChild(contentToModal.html);

                const lookupContainer = modalContent.querySelector('.form-horizontal');
                lookupContainer.appendChild(contentToModal.field.rootEl);

                this.populateListEquipments(routeId, contentToModal.field);
                this.addEventListenners();

            } catch (e) {

                const error = new Monet.Exception.ReturnError(this, "No add form equipment to modal.");
                error.console();

            }


        } else {

            const exception = new Monet.Exception.ReturnError(this, "No modal to add form equipment.");
            exception.console();

        }

    };

    this.validateForm = function () {

        var isValid = true;

        try {
            var erros = { "errorMessages": [] };
            var fields = document.querySelectorAll("#form_assign_equipment #equipment_list input[type='hidden']");
            var radios = document.querySelectorAll("#form_assign_equipment #equipment_list input[type='radio']");

            if (!fields.length) {

                erros.errorMessages.push(
                  Monet.Form.Messages.mountErrorMessageObject('Route.AssingDriver.equipmentNotSelected'));

            }

            if (radios.length > 0) {

                for (var i = 0; i < radios.length; i++) {

                    if (radios[i].checked) {
                        break;
                    }

                    if (i === (radios.length - 1)) {

                        erros.errorMessages.push(
                          Monet.Form.Messages.mountErrorMessageObject('Route.AssingDriver.equipmentPrincipalNotSelected'));

                    }
                }
            }

            if (erros.errorMessages.length > 0) {

                isValid = false;

                var monetMessage = new Monet.Form.Messages.InlineMessage();

                monetMessage.setScope("#form_assign_equipment");
                monetMessage.setInfoType("error");

                monetMessage.setMessage(erros);
                monetMessage.triggerMessage();

            }

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No validate form equipment.");
            error.console();

        }

        return isValid;

    };

    this.assignEquipmentLayout = function (data) {

        var layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingEquipment.btnSave"),
                                                "name": "btn_save_assign_equipment",
                                                "id": "btn_save_assign_equipment",
                                                "class": "btn",
                                                "style": "float:right;",
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingEquipment.btnExit"),
                                                "name": "btn_exit_assign_equipment",
                                                "id": "btn_exit_assign_equipment",
                                                "class": "btn"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "style": "position:relative; float:left; width: 100%",
                                        "class": "standard-form-buttons"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "monetInlineAlerContainer"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "hidden",
                                                "id": "route_id",
                                                "name": "route.id",
                                                "value": data.routeIdValue,
                                                "class": "modelAttribute"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span8"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "html": data.lookupEquipmentContent,
                                            "attributes": {
                                                "class": "form-horizontal"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span4"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "form_assign_equipment"
                    }
                }
            ]
        };

        return (new Monet.UI.LayoutGenerator(layout)).render();

    };

    this.constructFormAssignEquipment = function (routeId) {

        try {

            const label = Monet.I18n.getResourcesByKey("Route.AssingEquipment.labelEquipment");
            const field = new Monet.UI.Fields.PowerLookupList();

            field.setValue = function (itemCollection) {
                const hasPrimaryEquipment = itemCollection.some(equipment => equipment.get('rel')?.principal);

                itemCollection.forEach(item => {
                    const equipmentData = {};
                    const relativeEquipmentData = item.get('rel');

                    equipmentData.id = item.id;
                    equipmentData[this.displayKey] = item.get(this.displayKey);

                    if (relativeEquipmentData) {
                        equipmentData.principal = relativeEquipmentData.principal;
                    }

                    const findEquipment = this.listValue
                    .find(equipItem => equipItem.id === equipmentData.id);

                    if (!findEquipment) {
                        const isEquipmentPrincipal = equipmentData.principal;

                        this.listValue.push(equipmentData);
                        this.createItemLookupList(
                            equipmentData.id,
                            equipmentData[this.displayKey],
                            isEquipmentPrincipal,
                            hasPrimaryEquipment
                        );
                    }
                });
            };

            field.createItemLookupList = function (
                id,
                value,
                principal,
                hasPrimaryEquipment
            ) {

                const thereIsSomeSelected = document.querySelector('#equipment input[type="radio"]:checked');
                const entity = this.lookUpEntity.toLowerCase();
                const idItem = entity + '_' + id;
                const item = document.createElement('div');

                item.id = id;
                item.className = 'zebrado item_lookuplist_' + idItem;

                const description = document.createElement('div');
                description.className = 'title_item_added';
                description.innerHTML = value;

                const iconDestroy = document.createElement('div');
                iconDestroy.className = 'del_item_added';

                const link = document.createElement('div');
                link.className = 'table-action-destroylink';
                link.innerHTML = '&nbsp;';

                const divStyle = document.createElement('div');
                divStyle.style.clear = 'both';

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = entity + '[' + id + '].id';
                input.id = entity + '[' + id + '].id';
                input.className = 'modelAttribute';
                input.value = id;

                const principalField = document.createElement('input');
                principalField.type = 'radio';
                principalField.name = 'principal';
                principalField.id = 'item_' + id;

                let customRadio = document.createElement('label');
                customRadio.className = 'customRadio';
                customRadio.htmlFor = principalField.id;

                if (principal || (!hasPrimaryEquipment && !thereIsSomeSelected)) {
                    principalField.checked = true;
                }

                item.appendChild(principalField);
                item.appendChild(customRadio);
                item.appendChild(description);
                item.appendChild(iconDestroy);
                iconDestroy.appendChild(link);
                item.appendChild(divStyle);
                item.appendChild(input);

                this.divLookupListWrapper.appendChild(item);
                iconDestroy.addEventListener('click', (function (routeId, scope, nodeElement) {
                    return function () {
                        const successCallback = (scope, nodeElement) => {
                            afterRemoveItems?.();
                            scope.destroyItem(nodeElement);
                        };

                        updatePrimaryEquipment(routeId, successCallback(scope, nodeElement));
                    };
                })(routeId, this, item));

            };

            field.setId('equipment');
            field.setNameSpace('equipment');
            field.setLookUpEntity('Equipment');
            field.setDisplayKey('key');
            field.render();
            field.setTextLabel(label);
            field.setInputName('key');

            return {
                html: this.assignEquipmentLayout({ routeIdValue: routeId, lookupEquipmentContent: '' }),
                field: field
            };

        } catch (e) {
            var error = new Monet.Exception.ReturnError(this, "No form to assign driver.");
            error.console();
        }

    };

    this.loadingLookupItem = function () {
        var loadingImg = document.createElement('img');
        loadingImg.className = "loading_img loadingLookupItem";
        loadingImg.setAttribute('src', require("static/images/general/loading_blue.svg"));

        return loadingImg;
    };

    this.populateListEquipments = async function (routeId, lookupField) {

        var route = new App.Routers.Route();
        var dataToCollection = [];
        var equipmentCollection = new App.Collections.Equipments();
        var equipments = await route.getEquipmentsByRoute({ routeId: routeId });
        var equipmentsTotal = equipments.length;

        if (equipmentsTotal) {
            for (var i = 0; i < equipmentsTotal; i++) {

                var data = equipments[i].equipment;
                data.rel = {
                    id: equipments[i].id,
                    principal: equipments[i].principal
                };

                dataToCollection.push(data);
            }
        }

        equipmentCollection.add(dataToCollection);

        if (lookupField) {
            lookupField.setValue(equipmentCollection.models);
        }

        for (var j = 0, l = equipments.length; j < l; j++) {
            const lookupItem = document.querySelector('.item_lookuplist_equipment_' + equipments[j].equipment.id);

            if (lookupItem) {
                const oldIconDestroy = lookupItem.querySelector('.del_item_added');

                if (oldIconDestroy) {
                    oldIconDestroy.parentNode.removeChild(oldIconDestroy);
                    const iconDestroy = document.createElement('div');
                    iconDestroy.className = 'del_item_added';

                    const link = document.createElement('div');
                    link.className = 'table-action-destroylink';
                    link.innerHTML = '&nbsp;';

                    iconDestroy.appendChild(link);
                    lookupItem.insertBefore(this.loadingLookupItem(), lookupItem.firstChild);
                    lookupItem.insertBefore(iconDestroy, lookupItem.firstChild);

                    iconDestroy.addEventListener('click', (function (assignId, lookupField, lookupItem, routeId) {
                        return function () {
                            $(lookupItem).find('.del_item_added').hide();
                            $(lookupItem).find('.loadingLookupItem').show();

                            const successCallback = (isRemoved) => {
                                if (isRemoved) {
                                    const updatePrimarySuccess = () => {
                                        lookupField.destroyItem(lookupItem);
                                    };

                                    updatePrimaryEquipment(routeId, updatePrimarySuccess);
                                    afterRemoveItems?.();
                                }
                                else {
                                    $(lookupItem).find('.loadingLookupItem').hide();
                                    $(lookupItem).find('.del_item_added').show();
                                }
                            };

                            const errorCallback = () => {
                                $(lookupItem).find('.loadingLookupItem').hide();
                                $(lookupItem).find('.del_item_added').show();
                            };

                            const model = new App.Models.RouteEquipmentAssignment();
                            return model.unassignToRoute({ assignmentId: assignId, routeId }, successCallback, errorCallback);
                        };
                    })(equipments[j].id, lookupField, lookupItem, routeId));
                }
            }
        }
        const utils = new Greenmile.Route.ModalUtils();
        utils.removeAllActionListener(
          lookupField,
          equipments,
          'equipment',
          false,
          () => {
            afterRemoveItems?.();
          }
        );
    };

    var isFirstEquipmentList = function () {
        var itens = document.querySelectorAll("#form_assign_equipment #equipment_list input[type='hidden']");

        if (itens.length) {
            return false;
        }
        return true;
    };

    var getTemplateLookupItem = function (options) {
        var content = options.content;
        var checked = "";

        if (typeof(content.checked) !== "undefined") {
            if (content.checked) {
                checked = "checked='checked'";
            }
        } else if (isFirstEquipmentList()) {
            checked = "checked='checked'";
        }

        var data = {
            id: content.id,
            index: content.index,
            title: content.title,
            lookupEntity: options.lookupEntity,
            scope: options.scope,
            checked: checked
        };

        var layout = {
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "items": [
                                {
                                    "tag": "label",
                                    "html": data.title,
                                    "attributes": {
                                        "for": "item_data.id"
                                    }
                                },
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "id": "item_data.id",
                                        "type": "radio",
                                        "name": "principal",
                                        "data.checked": ""
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "title_item_added"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "table-action-destroylink"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "del_item_added"
                            }
                        },
                        {
                            "attributes": {
                                "style": "clear:both;"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "hidden",
                                "name": data.lookupEntity + "[" + data.index + "].id",
                                "id": data.lookupEntity + "[" + data.index + "].id",
                                "class": "modelAttribute",
                                "value": data.id
                            }
                        }
                    ],
                    "attributes": {
                        "id": data.lookupEntity + "_" + data.id,
                        "class": "zebrado item_lookuplist_" + data.lookupEntity + "_" + data.id
                    }
                }
            ]
        };
        return (new Monet.UI.LayoutGenerator(layout)).render().innerHTML;
    };

    var updatePrimaryEquipment = function (routeId, successCallback) {
        const radiosSelector = "#form_assign_equipment #equipment_list input[type='radio']";

        const getEquipmentSuccess = (equipmentArray) => {
            if (successCallback) {
                successCallback();
            }

            if (equipmentArray.length) {
                equipmentArray.forEach((equipment) => {
                    if (equipment.principal) {
                        const radio = document.querySelector(radiosSelector + "#item_" + equipment.equipment.id);
                        radio.checked = true;
                    }
                });
            }
            else {
                const radios = document.querySelectorAll(radiosSelector);
                if (radios.length) {
                    radios[0].checked = true;
                }
            }

        };

        const route = new App.Routers.Route();
        return route.getEquipmentsByRoute({ routeId }, getEquipmentSuccess);
    };

    this.assignEquipmentToRoute = () => {
      const btnSave = document.querySelector("#form_assign_equipment #btn_save_assign_equipment");

      const assignToRouteCallback = () => {
        this.modalForm.closeModalWindow();
        successCallback?.();
        btnSave.removeAttribute('disabled');
      };

      if (this.validateForm()) {
        btnSave.setAttribute('disabled', 'disabled');
        try {
          const selectorEquipments = "#form_assign_equipment #equipment_list input[type='hidden']";
          const selectorRadio = "#form_assign_equipment #equipment_list input[type='radio']";
          const equipments = document.querySelectorAll(selectorEquipments);
          const radios = document.querySelectorAll(selectorRadio);
          const model = new App.Models.RouteEquipmentAssignment();

          const totalEquipments = equipments.length;
          const listEquipment = [];

          for (let i = 0; i < totalEquipments; i++) {
            const equipment = equipments[i];
            const principal = radios[i].checked;

            const data = {
              route: {
                id: routeId
              },
              equipment: {
                id: equipment.value
              },
              principal: principal
            };

            listEquipment.push(data);
          }

          model.assignToRoute({ routeEquipments: listEquipment }, assignToRouteCallback, () => {
            btnSave.removeAttribute('disabled');
          });

          App.Objects.RouteDetails.updateRouteModel(routeId);
        } catch (e) {
          const error = new Monet.Exception.ReturnError(
            this,
            "No assign equipment to route.",
            e
          );
          error.console();
        }
      }
    };

    this.addEventListenners = function () {

        try {

            var that = this;

            var btnSave = document.querySelector("#form_assign_equipment #btn_save_assign_equipment");
            var btnExit = document.querySelector("#form_assign_equipment #btn_exit_assign_equipment");

            btnSave.onclick = function () {

                that.assignEquipmentToRoute();

            };

            btnExit.onclick = function () {

                that.modalForm.closeModalWindow();

            };


        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No add event listenner to form equipment.");
            error.console();

        }

    };

    var init = function (scope) {
        return function (scope) {
            const options = { width: 500, height: 400 };
            const callbacks = {
                onAfterShowModalForm: scope.addFormToModalContent
            };
            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
        }(scope);
    };

    init(this);

};
